import React from "react";
import { iconMap } from "../utils/iconMap";

export const Features = (props) => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="row">
          <h2 className="section-title text-center mt-3">Especialidades</h2>

          {props.data
            ? props.data.map((d, i) => {
                const Icon = iconMap[d.icon];

                return (
                  <div key={`${d.title}-${i}`} className="col-12 col-md-6">
                    {Icon && <Icon className="feature-icon" />}
                    <h3>{d.title}</h3>
                    <p>{d.text}</p>

                    {/* Botão com link individual */}
                    <a
                      href={d.link}
                      className="btn btn-custom btn-features btn-lg mt-1 mb-5"
                    >
                      Saiba Mais
                    </a>
                  </div>
                );
              })
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
